import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import axios from "axios";
import layer from "layui-layer";
import './assets/theme/index.css'
import './assets/css/global.css'
import {
  setupTrack,
  trackAction,
  trackApiRequest,
  extractBusinessCode,
  syncTrackIdentity
} from './utils/track'

const TRACK_ENDPOINT = process.env.VUE_APP_TRACK_API || 'https://track.wesitrans.com/track'

function silently(work, fallback) {
  try {
    return work()
  } catch (error) {
    return fallback
  }
}

function trackResponse(config, status, data, success) {
  silently(() => {
    const startedAt = Number(config && config.__trackStartedAt) || Date.now()
    const businessCode = extractBusinessCode(data)
    const codeLooksSuccessful = !/^(?:false|error|failed|failure|need_login|unauthorized|forbidden|[45]\d{2,4})$/i.test(String(businessCode))
    trackApiRequest(config, status, businessCode, Date.now() - startedAt, Boolean(success && codeLooksSuccessful))
    syncTrackIdentity()
  })
}

// 超时时间
axios.defaults.timeout = 20 * 1000
// 凭证
axios.defaults.withCredentials = true

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
  console.log(config)
  silently(() => { config.__trackStartedAt = Date.now() })
  // 在发送请求之前做些什么
  return config
}, function (error) {
  silently(() => trackApiRequest(error && error.config, 0, '', 0, false))
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
  trackResponse(response && response.config, response && response.status, response && response.data, true)
  // 对响应数据做点什么
  return response
}, function (error) {
  trackResponse(error && error.config, error && error.response && error.response.status, error && error.response && error.response.data, false)
  // 对响应错误做点什么
  return Promise.reject(error)
})

Vue.prototype.$http = axios
Vue.prototype.$layer = layer
Vue.prototype.$track = function (eventName, properties, eventType) {
  silently(() => trackAction(eventName, properties || {}, eventType || 'business_event'))
}

Vue.config.productionTip = false

silently(() => setupTrack(Vue, {
  appId: 'translate-user-center',
  endpoint: TRACK_ENDPOINT,
  router,
  getToken: () => window.localStorage.getItem('token') || ''
}))

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
